import * as React from "react";
import QueryComponent from 'core/api/QueryComponent';
import { Button, ITagProps, MenuItem } from "@blueprintjs/core";
import { ItemRenderer, MultiSelect, ItemPredicate } from "@blueprintjs/select";
import { Panel, IPanelProps } from "core/decorators/Panel";
import { ContributorPanelConfig } from "./ContributorPanelConfig";
import Loading from "common/fragments/Loading";
import { Entity, Field } from "typegraph";

const ContributorMultiSelect = MultiSelect.ofType<Contributor>();

@Entity({one: "contributor", many: "contributors"})
export class Contributor {
    @Field()
    id: string;

    @Field()
    name: string;

    @Field()
    designations: string;

    @Field()
	organization:string
}
export interface IContributorMultiSelectState {
    contributors: Contributor[];
	query:string
}
@Panel({id: "contributor-filter", configClass: ContributorPanelConfig, pageParams:true})
export class ContributorFilterPanel extends React.PureComponent<IPanelProps<ContributorPanelConfig> , IContributorMultiSelectState> {
    public state: IContributorMultiSelectState = {
        contributors: [],
        		query:''
    };

    public render() {
				const { contributors } = this.state;
		      const {config}= this.props;
				const getTagProps = (_value: string, index: number): ITagProps => ({
						minimal: config.tagMinimal,
				});
				const clearButton =
		contributors.length > 0 ? <Button icon="cross" minimal={true} onClick={this.handleClear} /> : undefined;

				return (
						<QueryComponent entity={Contributor} args={{query: this.state.query}} type="many">

{
										({data, loading}) => {
												if (loading) {
														return <Loading />;
												}

												return <ContributorMultiSelect
												openOnKeyDown={config.openOnKeyDown}
												resetOnSelect={config.reset}
												itemRenderer={this.renderContributor}
												itemsEqual={this.areContributorEqual}
												// we may customize the default filmSelectProps.items by
												// adding newly created items to the list, so pass our own
												items={data || []}
												onItemSelect={this.handleContributorSelect}
												noResults={<MenuItem disabled={true} text="No results." />}
												popoverProps={{ minimal: config.minimal }}
												tagRenderer={this.renderTag}
												tagInputProps={{ tagProps: getTagProps, onRemove: this.handleTagRemove, rightElement: clearButton }}
												selectedItems={this.state.contributors}
										/>;
										}
								}

								</QueryComponent>
				);
		}

		private renderTag = (contributor: Contributor) => contributor.name;

		// NOTE: not using Films.itemRenderer here so we can set icons.
		private renderContributor: ItemRenderer<Contributor> = (contributor, { modifiers, handleClick }) => {
				if (!modifiers.matchesPredicate) {
						return null;
				}
				return (
						<MenuItem
								active={modifiers.active}
								icon={this.isContributorSelected(contributor) ? "tick" : "blank"}
								key={contributor.id}
								label={contributor.name}
								onClick={handleClick}
								text={`${contributor.name}. ${contributor.designations}. ${contributor.organization}`}
								shouldDismissPopover={false}
						/>
				);
		}

		private handleTagRemove = (_tag: string, index: number) => {
				this.deselectContributor(index);
		}

		private getSelectedContributorIndex(contributor: Contributor) {
				return this.state.contributors.indexOf(contributor);
		}

		private isContributorSelected(contributor: Contributor) {
				return this.getSelectedContributorIndex(contributor) !== -1;
		}

		private deselectContributor(index: number) {
				const { contributors } = this.state;
				// Delete the item if the user manually created it.
				this.setState({
						contributors: contributors.filter((_contributor, i) => i !== index)
				});
		}
		private handleContributorSelect = (contributor: Contributor) => {
				if (!this.isContributorSelected(contributor)) {
						this.selectContributor(contributor);
				} else {
						this.deselectContributor(this.getSelectedContributorIndex(contributor));
				}
		}
		private selectContributor(contributor: Contributor) {
				this.selectContributors([contributor]);
		}

		private selectContributors(contributorToSelect: Contributor[]) {
				let nextContributor;
				const {  contributors } = this.state;
				contributorToSelect.forEach((contributor) => {
							if (contributors.some((contributor: Contributor) => contributor.id === contributorToSelect[0].id)) {
						nextContributor = !contributors.includes(contributor) ? [...contributors, contributor] : contributors;
							}
				});

				this.setState({
						contributors: nextContributor
				});
		}

	private handleClear = () => this.setState({ contributors: [] });
	private  areContributorEqual(contributor1: Contributor, contributor2: Contributor) {
		return contributor1.id.toLowerCase() === contributor2.id.toLowerCase();
		}
}



// WEBPACK FOOTER //
// ./src/panels/contributor/Contributor.panel.tsx